<form [formGroup]="contactInfoForm">
  <div class="row">
    <div class="column">
      <h3>Contact Info</h3>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business legal name</mat-label>
          <input formControlName="businessLegalName" matInput>
          <mat-error *ngIf="contactInfoForm.get('businessLegalName')?.hasError('required')">
            Business legal name is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business DBA name</mat-label>
          <input formControlName="businessDbaName" matInput>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Website URL</mat-label>
          <input formControlName="webSiteUrl" matInput>
          <mat-error *ngIf="contactInfoForm.get('webSiteUrl')?.hasError('pattern')">
            Please use a valid url.
          </mat-error>
        </mat-form-field>
      </div>
      <app-address-info-card [addressInfo]="account"></app-address-info-card>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary contact first name</mat-label>
          <input formControlName="primaryContactFirstName" matInput>
          <mat-error *ngIf="contactInfoForm.get('primaryContactFirstName')?.hasError('required')">
            Primary contact first name is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary contact last name</mat-label>
          <input formControlName="primaryContactLastName" matInput>
          <mat-error *ngIf="contactInfoForm.get('primaryContactLastName')?.hasError('required')">
            Primary contact last name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary contact email address</mat-label>
          <input formControlName="primaryContactEmail" matInput>
          <mat-error *ngIf="contactInfoForm.get('primaryContactEmail')?.hasError('required')">
            Primary contact email address is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm.get('primaryContactEmail')?.hasError('email')">
            Please use a valid email.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Primary contact phone number</mat-label>
          <input formControlName="primaryContactPhoneNumber" matInput>
          <mat-error *ngIf="contactInfoForm.get('primaryContactPhoneNumber')?.hasError('required')">
            Primary contact phone number is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm.get('primaryContactPhoneNumber')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-divider [vertical]="true"></mat-divider>
    <div class="column">
      <h3>Other Info</h3>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status" placeholder="Status">
            <mat-option value="ACTIVE">
              <app-status-indicator [isDropdownOption]="true" statusText="Active"></app-status-indicator>
            </mat-option>
            <mat-option value="CLOSED">
              <app-status-indicator [isDropdownOption]="true" statusText="Closed"></app-status-indicator>
            </mat-option>
            <mat-option value="INACTIVE">
              <app-status-indicator [isDropdownOption]="true" statusText="Inactive"></app-status-indicator>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="contactInfoForm.get('status')?.hasError('required')">
            Status is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Filing preference</mat-label>
          <mat-select formControlName="billingFreq" placeholder="filing preference">
            <mat-option [value]="'M'">Monthly</mat-option>
            <mat-option [value]="'Q'">Quarterly</mat-option>
          </mat-select>
          <mat-error *ngIf="contactInfoForm.get('billingFreq')?.hasError('required')">
            Filing preference is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Credit</mat-label>
          <input appCurrencyInput="USD" formControlName="credit" matInput type="float">
          <mat-error *ngIf="contactInfoForm.get('credit')?.hasError('required')">
            Credit is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm.get('credit')?.hasError('pattern')">
            Please insert just numbers.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <app-licenses [license]="account.entityLicense" class="column"></app-licenses>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>eSignature</mat-label>
          <input formControlName="eSignature" matInput>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
